import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoNotificheSdiStep2Component } from './conservazione-carica-documento-notifiche-sdi-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-notifiche-sdi-step2', {
            url: '/conservazione-carica-notifiche-sdi',
            ncyBreadcrumb: {
                label: 'Carica Notifica SdI',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-notifiche-sdi-step2 flex="100"></conservazione-carica-documento-notifiche-sdi-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoNotificheSdiStep2Module: string = ng
    .module('conservazione-carica-documento-notifiche-sdi-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoNotificheSdiStep2', ConservazioneCaricaDocumentoNotificheSdiStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-notifiche-sdi-step2/conservazione-carica-documento-notifiche-sdi-step2.module.ts